'use strict';

exports.__esModule = true;

var _polished = require('polished');

var _colors = require('./colors');

var _colors2 = _interopRequireDefault(_colors);

var _baseTheme = require('./baseTheme');

var _baseTheme2 = _interopRequireDefault(_baseTheme);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var buttonBoxShadow = '0 0 2px 0 rgba(0, 0, 0, 0.12), 0 2px 2px 0 rgba(0, 0, 0, 0.24)';

var darkTheme = Object.assign({}, _baseTheme2.default, {
  typography: {
    color: _colors2.default.white
  },
  buttons: {
    primary: {
      backgroundColor: _colors2.default.white,
      color: _colors2.default.black87,
      boxShadow: buttonBoxShadow,
      hoverColor: (0, _polished.darken)(0.05, _colors2.default.white),
      activeColor: (0, _polished.darken)(0.1, _colors2.default.white),
      focusColor: (0, _polished.darken)(0.1, _colors2.default.white)
    },
    secondary: {
      color: _colors2.default.white,
      border: '2px solid #938fa3',
      hoverColor: 'rgba(255, 255, 255, 0.05)',
      activeColor: 'rgba(255, 255, 255, 0.1)',
      focusColor: 'rgba(255, 255, 255, 0.1)'
    },
    link: {
      color: _colors2.default.white,
      hoverColor: 'rgba(255, 255, 255, 0.05)',
      activeColor: 'rgba(255, 255, 255, 0.1)',
      focusColor: 'rgba(255, 255, 255, 0.1)'
    },
    destructive: {
      backgroundColor: _colors2.default.errorRed,
      color: _colors2.default.white,
      boxShadow: buttonBoxShadow,
      hoverColor: (0, _polished.darken)(0.05, _colors2.default.errorRed),
      activeColor: (0, _polished.darken)(0.1, _colors2.default.errorRed),
      focusColor: (0, _polished.darken)(0.1, _colors2.default.errorRed)
    },
    icon: {
      color: _colors2.default.white,
      hoverColor: 'rgba(255, 255, 255, 0.05)',
      activeColor: 'rgba(255, 255, 255, 0.1)',
      focusColor: 'rgba(255, 255, 255, 0.1)',
      borderRadius: '50%',
      width: '40px',
      height: '40px'
    }
  }
});

exports.default = darkTheme;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-dev/thread/lib/theme/darkTheme.js
// module id = 1059
// module chunks = 29